import script from "./ImpostorPreviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpostorPreviewCard.vue?vue&type=script&setup=true&lang=js"

import "./ImpostorPreviewCard.vue?vue&type=style&index=0&id=6574bd84&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6574bd84"]])

export default __exports__